import {Currency, CurrencyAmount} from '@shared/dynamo_model';

export function cents(cents: number): CurrencyAmount {
  return {cents, currency: Currency.Euro};
}

export function addCurrencyAmount(
  amount1: CurrencyAmount,
  amount2: CurrencyAmount | undefined
): CurrencyAmount {
  if (!amount2) {
    return amount1;
  }
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (amount1.currency !== amount2.currency) {
    throw new Error(
      `Could not add together different currencies (${amount1.currency} + ${amount2.currency})`
    );
  }

  return {cents: amount1.cents + amount2.cents, currency: amount1.currency};
}

export function multiplyCurrencyAmount(multiplier: number, amount: CurrencyAmount): CurrencyAmount {
  return {cents: amount.cents * multiplier, currency: amount.currency};
}
